import React from 'react';
import { clsx } from 'clsx';
import { formatAmountWithSpacesAndSymbol } from '@/lib/amountUtils';
import { Slider } from '@/ui/components/Slider';
import styles from './CreditLineAmountSelector.module.scss';
import { AMOUNT_SLIDER_STEP } from '@/features/offer';

export interface CreditLineAmountSelectorProps {
  creditAmount: number;
  dailyInterest: number;
  onAmountChange: (amount: number) => void;
  className?: string;
  minAmount: number;
  maxAmount: number;
}

export const CreditLineAmountSelector: React.FC<
  CreditLineAmountSelectorProps
> = ({
  creditAmount,
  dailyInterest,
  onAmountChange,
  className,
  minAmount,
  maxAmount,
}) => {
  const handleSliderChange = (value: number) => {
    onAmountChange(value);
  };

  const formatAmount = (amount: number) => {
    return formatAmountWithSpacesAndSymbol(amount, 'lei');
  };

  return (
    <div className={clsx(styles.amountCard, className)}>
      <div className={styles.amountRow}>
        {/* Withdrawn Amount */}
        <div className={styles.amountItem}>
          <p className={styles.amountLabel}>Suma retrasă</p>
          <div className={styles.amountValue}>
            <span className={styles.amountText}>
              {formatAmountWithSpacesAndSymbol(creditAmount, 'lei')}
            </span>
          </div>
        </div>

        {/* Daily Interest */}
        <div className={styles.amountItem}>
          <p className={styles.amountLabel}>Dobândă</p>
          <div className={styles.amountValue}>
            <span className={styles.amountText}>
              {formatAmountWithSpacesAndSymbol(dailyInterest, 'lei/zi')}
            </span>
          </div>
        </div>
      </div>

      {/* Slider Section */}
      {minAmount !== maxAmount && (
        <div className={styles.sliderSection}>
          <Slider
            value={creditAmount}
            min={minAmount}
            max={maxAmount}
            step={AMOUNT_SLIDER_STEP}
            onChange={handleSliderChange}
            formatValue={formatAmount}
            className={styles.slider}
          />
        </div>
      )}
    </div>
  );
};
